import React from "react";
import { Helmet as RHelmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const helmetData = [
    {
        path: "/",
        title: "Hello Kids Camp | Anglické příměstské tábory Brno - zábavná výuka pro děti",
        description: "Zábavné anglické příměstské tábory v Brně pro předškoláky a děti z 1. stupně ZŠ. Hry, tvoření, dobrodružství a přátelští lektoři.",
    },
    {
        path: "/program/safari",
        title: "Hello Kids Camp | Safari dobrodružství | Anglický tábor pro děti",
        description: "Anglický příměstský tábor v Brně pro děti 4-7 let. Hry, písničky, tvoření a výlet do ZOO | Angličtina přirozeně a zábavně každý den.",
    },
    {
        path: "/program/magic",
        title: "Hello Kids Camp | Škola kouzel | Anglický tábor pro děti",
        description: "Anglický tábor v Brně pro děti 8-11 let. Kouzla, záhady, tvoření a dobrodružné úkoly | Angličtina aktivně, zábavně a s nadšením.",
    },
    {
        path: "/programy",
        title: "Hello Kids Camp | Zábavné a naučné programy pro děti",
        description: "Anglický příměstský tábor v Brně | Kouzla, záhady, tvoření a dobrodružné úkoly | Angličtina aktivně, zábavně a s nadšením.",
    },
    {
        path: "/podminky",
        title: "Hello Kids Camp | Obchodní podmínky",
        description: "Všeobecné obchodní podmínky.",
    },
    {
        path: "/zasady",
        title: "Hello Kids Camp | Ochrana soukromí | GDPR",
        description: "Zásady ochrany osobních údajů pro příměstské tábory.",
    },
    {
        path: "/cookies",
        title: "Hello Kids Camp | Cookies",
        description: "Informace o používání cookies na webu pro příměstské tábory.",
    },
];

function useHelmetData(path) {
    return helmetData.find(h => h.path === path) || helmetData[0];
}

export default function Helmet({ children, baseData = false }) {
    const location = useLocation();
    const data = useHelmetData(location.pathname);
    if (!data) return children;

    return (
        <>
            <RHelmet key={location.pathname}>
                <title translate="no">{data.title}</title>
                <meta name="description" content={data.description} />
                <meta property="og:title" content={data.title} />
                <meta property="og:description" content={data.description} />
                <meta name="twitter:title" content={data.title} />
                <meta name="twitter:description" content={data.description} />
            </RHelmet>
            {children}
        </>
    );
}
